export const lensAddresses = {
  accountLens: "0x89990c6AAbbE9327a4EbD454CdCbE59b0aC8b886",
  eulerEarnVaultLens: "0x8787ce8F852ABC9b928589d830e21D0e7c4080eE",
  irmLens: "0xBd3840ec2A74ff4d0D97374BBE3a89ae72491255",
  oracleLens: "0x8120916856e8c021edDb86bce77e4d0875da0694",
  utilsLens: "0x187DA6612c5B2C1819E6F40742e48BE989F0Fb26",
  vaultLens: "0xD77C086143E9177D929B17964672d44cbC1e88D0",
} as const
